export const api = {
  measurespeed: {
    addMeasureSpeed: '/vas/measurespeed/addMeasureSpeed.json', //测速配置新增
    updateMeasureSpeed: '/vas/measurespeed/updateMeasureSpeed.json', //测速配置修改
    deleteMeasureSpeed: '/vas/measurespeed/deleteMeasureSpeed.json', //测速配置删除
    queryMeasureSpeed: '/vas/measurespeed/queryMeasureSpeedByPage.json', //测速配置列表查询
    startOrStop: '/vas/measurespeed/startOrStopMeasureSpeed.json', //测速配置启用/禁用接口
    queryArea: '/vas/video/queryRegionalEquipmentTree.json', //查询摄像机
    queryOverSpeedRecordList: '/vas/measurespeed/queryOverSpeedRecordList.json', //测速配置记录列表查询  
    queryMeasureSpeedDetail: '/vas/measurespeed/queryMeasureSpeedDetail.json', //测速配置详情接口
    exportOverSpeedRecordList: '/vas/measurespeed/exportOverSpeedRecordList.json', //导出超速记录
  }
}